import { render, staticRenderFns } from "./TheDocumentAttachments.vue?vue&type=template&id=51697f3e&scoped=true&"
import script from "./TheDocumentAttachments.vue?vue&type=script&lang=js&"
export * from "./TheDocumentAttachments.vue?vue&type=script&lang=js&"
import style0 from "./TheDocumentAttachments.vue?vue&type=style&index=0&id=51697f3e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51697f3e",
  null
  
)

export default component.exports